import jQuery from 'jquery';

export default () => {
	jQuery('#code-form button').click(function(){
		var $button = jQuery(this);
		$button.attr('disabled', true);
		jQuery.ajax({
			url: '/wp-admin/admin-ajax.php',
			dataType: 'JSON',
			data: {
				action: 'pp_check_code',
				code: jQuery('#code').val()
			},
			success: function (res) {
				if (res.status == 'ok') {
					window.location = res.data;
				} else {
					jQuery('#code').val('');
				}
				$button.attr('disabled', false);
			},
			error: function () {
				$button.attr('disabled', false);
			}
		});
		return false;
	});
}


// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/code.js